import { NAME } from './constants';

export const RESET_APP_DATA = `${NAME}/RESET_APP_DATA`;
export const FETCH_AUTH_SITE_LIST = `${NAME}/FETCH_AUTH_SITE_LIST`;
export const SET_AUTH_SITE_LIST = `${NAME}/SET_AUTH_SITE_LIST`;
export const SET_AUTH_SITE_FILTERS = `${NAME}/SET_AUTH_SITE_FILTERS`;
export const SET_IS_MOBILE = `${NAME}/SET_IS_MOBILE`;
